import React, { useContext, useEffect, useState, useRef } from "react";
import GoogleMapReact from "google-map-react";
// import LocationPin from "../images/location-pin.svg";
// import GreenPin from "../images/green-pin.svg";
// import OrangePin from "../images/orange-pin.svg";
import LiveLocationPin from "../images/live-location-pin.svg";
// import BlackPin from "../images/black-pin.svg";
import { LocationContext } from "./LocationContext";
import { LiaExpandSolid, LiaCompressSolid } from "react-icons/lia";
import { TbRefresh } from "react-icons/tb";
import LocationPin from "./locationPin";
import { CANVASSING_LANGUAGE_BARRIER_OPTIONS } from "../constants";
import { useTheme } from "../context/ThemeContext";
import { getDispositionColor } from "../utils/dispositionColors";

const TrackingMap = ({
  dataList,
  mapOptions,
  latLngMap,
  handleOnLoad,
  loading,
  handleEditClick,
  // radius = 8046.72,
  radius = 402.336,
}) => {
  const [activeMarker, setActiveMarker] = useState(null);
  const { locationPermission, location } = useContext(LocationContext);
  const dispositionColors = useTheme()?.theme?.dispositionColors;
  const [mapCenter, setMapCenter] = useState({
    lat: location?.latitude,
    lng: location?.longitude,
  });
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [reload, setReload] = useState(false);
  const mapRef = useRef(null);
  const mapsRef = useRef(null);
  const circleRef = useRef(null); // Ref for the circle

  const defaultCenter = {
    lat: location?.latitude,
    lng: location?.longitude,
  };

  const handleActiveMarker = (markerId) => {
    setActiveMarker(markerId === activeMarker ? null : markerId);
  };

  useEffect(() => {
    if (dataList.length > 0) {
      const avgLat =
        dataList.reduce((sum, data) => sum + latLngMap[data.id]?.lat, 0) /
        dataList.length;
      const avgLng =
        dataList.reduce((sum, data) => sum + latLngMap[data.id]?.lng, 0) /
        dataList.length;

      if (!isNaN(avgLat) && !isNaN(avgLng)) {
        setMapCenter({ lat: avgLat, lng: avgLng });
      }
    }
    setReload(false);
  }, [dataList, latLngMap, reload]);

  useEffect(() => {
    if (
      locationPermission &&
      Object.keys(location).length > 0 &&
      mapRef.current &&
      mapsRef.current
    ) {
      drawCircle();
      mapRef.current.setZoom(12);
    } else if (mapRef.current && mapsRef.current) {
      mapRef.current.setZoom(9);
      if (circleRef.current) {
        // circleRef.current = null;
        circleRef.current.setMap(null);
      }
    }
  }, [locationPermission, location, reload]);

  useEffect(() => {
    if (locationPermission && mapRef.current && mapsRef.current) {
      drawCircle();
      mapRef.current.setZoom(12);
    }
  }, []);

  useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullScreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
    };
  }, []);

  const handleApiLoaded = ({ map, maps }) => {
    mapRef.current = map;
    mapsRef.current = maps;

    if (locationPermission) {
      drawCircle();
    }
  };

  const drawCircle = () => {
    circleRef.current = new mapsRef.current.Circle({
      strokeColor: "#7C83FF",
      strokeOpacity: 0.4,
      strokeWeight: 2,
      fillColor: "#7C83FF",
      fillOpacity: 0.35,
      map: mapRef.current,
      center: { lat: location.latitude, lng: location.longitude },
      radius,
    });
  };

  const handleScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullScreen(true);
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
      setIsFullScreen(false);
    }
  };

  if (loading) return null;
  const handleMapRefresh = () => {
    setReload(true);
  };
  return (
    <div
      className={`${
        isFullScreen
          ? "w-full h-full absolute top-0 right-0 bottom-0 left-0 z-50"
          : "w-full h-full relative"
      }`}
    >
      <div
        className="absolute z-40 right-2 top-2 cursor-pointer bg-white p-2"
        onClick={handleScreen}
      >
        {isFullScreen ? (
          <LiaCompressSolid size={25} />
        ) : (
          <LiaExpandSolid size={25} />
        )}
      </div>
      <div
        className="absolute z-40 right-14 top-2 cursor-pointer bg-white p-2"
        onClick={handleMapRefresh}
      >
        <TbRefresh size={25} />
      </div>

      <GoogleMapReact
        key={reload}
        bootstrapURLKeys={{ key: "AIzaSyBwBtxw1WbNeANR4SlUgLHN3nuhF1qPaWs" }}
        defaultCenter={locationPermission ? defaultCenter : mapCenter}
        center={locationPermission ? defaultCenter : mapCenter}
        defaultZoom={mapOptions.zoom || 9}
        options={mapOptions}
        onClick={() => setActiveMarker(null)}
        onGoogleApiLoaded={handleApiLoaded}
        yesIWantToUseGoogleMapApiInternals
      >
        {dataList?.map((data, i) => {
          if (data.is_check) {
            const markerPosition = latLngMap[data.id];
            if (!markerPosition) return null;
            return (
              <CustomMarker
                key={data.id}
                id={i}
                lat={markerPosition?.lat}
                lng={markerPosition?.lng}
                householdDisposal={data?.properties?.household_disposition}
                dispositionColors={dispositionColors}
                barrierLanguage={data?.properties?.canvassing_language_barrier}
                onClick={() => {
                  handleEditClick(data);
                  handleActiveMarker(data.id);
                }}
              />
            );
          }
          return null;
        })}

        {locationPermission && Object.keys(location).length > 0 && (
          <CustomMarker
            lat={location.latitude}
            lng={location.longitude}
            isLive
          />
        )}
      </GoogleMapReact>
    </div>
  );
};

const CustomMarker = ({
  id,
  lat,
  lng,
  onClick,
  barrierLanguage,
  householdDisposal,
  dispositionColors,
  isLive,
}) =>
  isLive ? (
    <img
      src={LiveLocationPin}
      alt="live location"
      style={{
        width: "48px",
        height: "50px",
        cursor: "pointer",
        position: "absolute",
        transform: "translate(-50%, -50%)",
      }}
      lat={lat}
      lng={lng}
    />
  ) : (
    <LocationPin
      color={getDispositionColor(householdDisposal, dispositionColors)}
      content={
        CANVASSING_LANGUAGE_BARRIER_OPTIONS?.find(
          (item) => barrierLanguage === item?.value
        )?.pin
      }
      alt="Location Pin"
      style={{
        width: "48px",
        height: "50px",
        cursor: "pointer",
        position: "absolute",
        transform: "translate(-50%, -50%)",
      }}
      onClick={!isLive && onClick}
      lat={lat}
      lng={lng}
    />
  );
export default TrackingMap;
